var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", eager: "", "max-width": "600" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card-title",
        { staticClass: "navy darken-1 white--text" },
        [
          _vm.isAdminSet
            ? _c(
                "div",
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("edit")]
                  ),
                  _vm._v("\n        Modifica amministratore asta\n      "),
                ],
                1
              )
            : _c("div", [_vm._v("Imposta amministratore asta")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { depressed: "", light: "", icon: "" },
              on: { click: _vm.dismiss },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-sheet", { staticClass: "white" }, [
        _c(
          "div",
          { staticClass: "pa-4" },
          [
            !_vm.isAdminSet
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mb-4 font-weight-bold",
                    attrs: {
                      dense: "",
                      text: "",
                      color: "error",
                      icon: "warning",
                    },
                  },
                  [
                    _vm._v(
                      "Prima di iniziare si deve impostare un amministratore d'asta."
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-alert",
              { attrs: { dense: "", text: "", color: "cyan darken-2" } },
              [
                _vm.asta_squadre_array.length > 0
                  ? _c(
                      "div",
                      { staticClass: "py-4" },
                      [
                        _c("v-select", {
                          key: _vm.adminSelectKey,
                          staticClass: "admin-select-cyan",
                          attrs: {
                            items: _vm.adminSquadreOptions,
                            "item-text": "name",
                            "item-value": "id",
                            "item-disabled": "disabled",
                            "menu-props": {
                              offsetY: true,
                              contentClass: "admin-squadre-menu",
                            },
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            placeholder: "Seleziona amministratore d'asta",
                          },
                          on: { change: _vm.change },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "admin-squadra-option" },
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            staticClass: "mr-3",
                                            attrs: { size: "32" },
                                          },
                                          [
                                            _c("img", {
                                              attrs: { src: item.pic },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "stato mr-2",
                                          class: item.presenceClass,
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "admin-squadra-name" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("v-list-item-avatar", [
                                      _c("img", { attrs: { src: item.pic } }),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _c("span", {
                                            staticClass: "stato mr-2",
                                            class: item.presenceClass,
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "admin-squadra-name",
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1079026860
                          ),
                          model: {
                            value: _vm.selectedAdminUid,
                            callback: function ($$v) {
                              _vm.selectedAdminUid = $$v
                            },
                            expression: "selectedAdminUid",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "text-center pa-4" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n          Nessuna squadra a cui poter assegnare il ruolo di Amministratore\n          d'asta.\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { rounded: "", small: "", outlined: "" },
                            on: {
                              click: function ($event) {
                                return _vm.checkAllineamentoRose(true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          Check allineamento squadre\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("div", [_vm._v(" L'amministratore d'asta:")]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "E' l'unica persona che può cambiare le impostazioni, far partire o fermare l'asta etc..."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("b", { staticClass: "error--text" }, [
                      _vm._v(
                        "Deve rimanere SEMPRE ONLINE (pallino verde) o Asta\n            Live si bloccherà"
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "cyan--text", attrs: { small: "" } },
                      [_vm._v("info")]
                    ),
                    _vm._v(
                      " Utile se l'" +
                        _vm._s(_vm.adminLegaDivisioneLabel) +
                        " vuole delegare la gestione di Asta Live a un altro partecipante dell'asta"
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "cyan--text", attrs: { small: "" } },
                      [_vm._v("info")]
                    ),
                    _vm._v(
                      " Puó essere utile cambiare l'amministratore d'asta durante il corso dell'asta se quello attuale ha completato la rosa e decide di abbandonare Asta Live. Diventerebbe quindi col pallino rosso e Asta Live, per quanto scritto sopra, si bloccherebbe. In tal caso basta appunto cambiare l'amministratore d'asta per far proseguire l'asta normalmente\n\n          "
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.Config.STANDALONE
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mt-4",
                    attrs: { dense: "", text: "", color: "warning darken-2" },
                  },
                  [
                    _c("b", [
                      _vm._v(
                        "Chi ha il permesso di impostare/cambiare l'amministratore d'asta?"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      key: _vm.adminPermissionSelectKey,
                      staticClass: "mt-2 mb-2 admin-select-warning",
                      attrs: {
                        value: _vm.adminPermission,
                        items: _vm.adminPermissionOptions,
                        "item-text": "text",
                        "item-value": "value",
                        "menu-props": {
                          offsetY: true,
                          contentClass: "admin-permission-menu",
                        },
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                      },
                      on: { change: _vm.saveAdminPermission },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "selection",
                            fn: function (ref) {
                              var item = ref.item
                              return [_c("span", [_vm._v(_vm._s(item.text))])]
                            },
                          },
                          {
                            key: "item",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-list-item-content",
                                  { staticClass: "admin-permission-option" },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass:
                                          "admin-permission-option-title font-weight-bold",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.text) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-subtitle",
                                      {
                                        staticClass:
                                          "admin-permission-option-description",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.description) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4217486541
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "caption" },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "warning--text text--darken-2",
                            attrs: { small: "" },
                          },
                          [_vm._v("info")]
                        ),
                        _vm._v(
                          " A prescindere dalla scelta, l'" +
                            _vm._s(_vm.adminLegaDivisioneLabel) +
                            " potrá sempre cambiare l'amministratore d'asta.\n              "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-leghe-info mt-3" }, [
                      _vm.adminLegaUid
                        ? _c(
                            "div",
                            { staticClass: "admin-leghe-info-row" },
                            [
                              _c(
                                "v-avatar",
                                { staticClass: "mr-2", attrs: { size: "28" } },
                                [
                                  _vm.adminLegaInfo.pic
                                    ? _c("img", {
                                        attrs: { src: _vm.adminLegaInfo.pic },
                                      })
                                    : _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("person"),
                                      ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "admin-leghe-info-label" },
                                  [_vm._v("Amministratore di lega")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "admin-leghe-info-name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.adminLegaInfo.name ||
                                          _vm.adminLegaUid
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasDivisioni
                        ? _c(
                            "div",
                            { staticClass: "admin-leghe-info-row mt-2" },
                            [
                              _c(
                                "v-avatar",
                                { staticClass: "mr-2", attrs: { size: "28" } },
                                [
                                  _vm.adminDivisioneInfo.pic
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.adminDivisioneInfo.pic,
                                        },
                                      })
                                    : _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("person"),
                                      ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "admin-leghe-info-label" },
                                  [_vm._v("Amministratore di divisione")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "admin-leghe-info-name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.adminDivisioneInfo.name ||
                                          _vm.adminDivisioneUid ||
                                          "Non ancora impostato"
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }